const BREAKPOINTS = {
  mobile: 640,
};

export const QUERIES = {
  mobileAndUp: `(min-width: ${BREAKPOINTS.mobile}px)`,
};
